module.exports = __webpack_public_path__ + "static/media/withdraw.980bf314.png";